import React from "react";

const Minuts = () => {
  return <div></div>;
};

export default Minuts;
